import { AxiosInstance } from 'axios';
import MockAdapter from 'axios-mock-adapter';
import mocks from '_core/Mocks';
import { IMockProps, InitializeTypes } from '_core/types';
import { Bundle, isValue } from '_core/util';
import { Logger } from '../logger';

export const configureMock = (
  instance: AxiosInstance,
  _config: InitializeTypes,
): string[] => {
  let lstMocksEnabled: string[] = [];

  if (_config.service.environment === 'MOCK') {
    const mockAdapter: MockAdapter = new MockAdapter(instance, {
      onNoMatch: 'passthrough',
      delayResponse: 1000,
    });
    Bundle.setValue('mockAdapter', mockAdapter);

    lstMocksEnabled = createMocks(mockAdapter);
  } else if (_config.lstApisMock && _config.lstApisMock.length > 0) {
    const mockAdapter: MockAdapter = new MockAdapter(instance, {
      onNoMatch: 'passthrough',
      delayResponse: 1000,
    });
    Bundle.setValue('mockAdapter', mockAdapter);
    lstMocksEnabled = createMocks(mockAdapter, _config.lstApisMock);
  }
  return lstMocksEnabled;
};

export const cleanMocks = (): boolean => {
  const mockAdapter = Bundle.getValue('mockAdapter');
  if (isValue(mockAdapter)) {
    try {
      mockAdapter.restore();
      mockAdapter.resetHandlers();
      mockAdapter.reset();
    } catch (error) {
      Logger.error(error);
    }
  }
  return true;
};

const createMocks = (
  mockAdapter: MockAdapter,
  lstApisMock?: string[],
): string[] => {
  const lstMocksEnabled = [];
  for (const item of mocks) {
    if (
      lstApisMock &&
      lstApisMock.length > 0 &&
      lstApisMock?.indexOf(item.configRequest.path) === -1
    ) {
      continue;
    }
    if (lstMocksEnabled.indexOf(item.configRequest.path) === -1) {
      lstMocksEnabled.push(item.configRequest.path);
    }

    switch (item.configRequest.method) {
      case 'POST': {
        createMockPost(mockAdapter, item);
        break;
      }
      case 'PUT': {
        createMockPut(mockAdapter, item);
        break;
      }
      case 'GET': {
        createMockGet(mockAdapter, item);
        break;
      }
      default: {
        break;
      }
    }
  }
  return lstMocksEnabled;
};

const createMockPost = (mockConfig: MockAdapter, mock: IMockProps) => {
  const urlMock = new RegExp(`${mock.configRequest.path}$`);
  const { status, data, headers } = mock.configResponse;
  const newHeaders = { ...headers, mockEnabled: true };
  const body = mock.configRequest.body;
  const newData = { data: data };
  if (body) {
    mockConfig.onPost(urlMock, body).reply(status, newData, newHeaders);
  } else {
    mockConfig.onPost(urlMock).reply(status, newData, newHeaders);
  }
};

const createMockPut = (mockConfig: MockAdapter, mock: IMockProps) => {
  const urlMock = new RegExp(`${mock.configRequest.path}$`);
  const { status, data, headers } = mock.configResponse;
  const newHeaders = { ...headers, mockEnabled: true };
  const body = mock.configRequest.body;
  const newData = { data: data };
  if (body) {
    mockConfig.onPut(urlMock, body).reply(status, newData, newHeaders);
  } else {
    mockConfig.onPut(urlMock).reply(status, newData, newHeaders);
  }
};

const createMockGet = (mockConfig: MockAdapter, mock: IMockProps) => {
  const urlMock = new RegExp(`${mock.configRequest.path}$`);
  const { status, data, headers } = mock.configResponse;
  const newHeaders = { ...headers, mockEnabled: true };
  const params = mock.configRequest.params;
  const newData = { data: data };
  if (params) {
    mockConfig
      .onGet(urlMock, { params: params })
      .reply(status, newData, newHeaders);
  } else {
    mockConfig.onGet(urlMock).reply(status, newData, newHeaders);
  }
};
